import React from "react";
import MasterLayout from "../masterLayout/MasterLayout";
import Breadcrumb from "../components/Breadcrumb";
import UsersTable from "../components/UsersTable";
import { ToastContainer } from 'react-toastify';

const UsersCustomersPage = () => {
  return (
    <MasterLayout>
      <ToastContainer />
      <Breadcrumb title="Müşteriler" />
      <UsersTable role="customers" title="Müşteriler" />
    </MasterLayout>
  );
};

export default UsersCustomersPage;

